import type { FunctionComponent } from 'react';
import { SearchLandingPagePropertyCard } from '../SearchLandingPagePropertyCard/SearchLandingPagePropertyCard';
import { SearchResult } from '../../types';

interface SearchLandingPageResultsProps {
  results: SearchResult[];
  preloadItemCount?: number;
}

export const SearchLandingPageResults: FunctionComponent<SearchLandingPageResultsProps> = ({
  results,
  preloadItemCount = 0,
}) => {
  return (
    <>
      {results.map((result, index) => {
        return (
          <SearchLandingPagePropertyCard
            content={result}
            key={index}
            preloadImage={preloadItemCount > index}
          />
        );
      })}
    </>
  );
};
